<template lang="pug">
button(
  @click="$emit('click')"
  :class="['botao', variant, iconOnly && 'icon-only']"
)
  span.icone-left(v-if="iconLeft || iconOnly")
    slot(name="icon-left")
  span.texto(v-if="!iconOnly")
    slot()
  span.icone-right(v-if="iconRight")
    slot(name="icon-right")
</template>

<script>
export default {
  name: 'Botao',
  props: {
    iconLeft: {
      type: Boolean,
      default: false
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default'
    },
    iconOnly: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.botao {
  height: 40px;
  background-color: $corVerdeClaro;
  color: #000;
  border: none;
  border-radius: 6px;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(183, 255, 0, 0.9);
  }

  &.negative {
    background-color: #000;
    color: #fff;
    border: 1px solid #3d3d3d;

    &:hover {
      background-color: #3d3d3d;
      color: #b7ff00;
      border-color: #b7ff00;
    }
  }

  &.icon-only {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    padding: 0;
    justify-content: center;

    .icone-left,
    .icone-right {
      margin: 0;
    }

    .texto {
      display: none;
    }
  }

  .icone-left,
  .icone-right {
    display: inline-flex;
    align-items: center;
  }

  .icone-left {
    margin-right: 15px;
    width: auto;
  }

  .icone-right {
    margin-left: 15px;
    width: auto;
  }

  .texto {
    width: auto;
    display: inline-block;
    line-height: 0;
  }
}
</style>
